export interface AppState {
  id: number
  visibility: Visibility
  selectionStatus: SelectionStatus
  standardLevelSubjectNumber: number
  highLevelSubjectNumber: number
}

export enum Visibility {
  VISIBLE = 'VISIBLE',
  NOT_VISIBLE = 'INVISIBLE'
};

export enum SelectionStatus {
  OPEN = 'OPEN',
  CLOSED = 'CLOSED',
  OPEN_FOR_CORRECTIONS = 'OPEN_FOR_CORRECTIONS'
};
